import React from 'react';
import { AboutUs } from '../components/global/aboutUs';
import {Header} from '../components/global/header';
import {Footer} from '../components/global/footer';

const AboutUsPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <AboutUs />
      <Footer />
    </div>
  );
};

export default AboutUsPage;
